import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DashboardLayout from "@/pages/DashboardLayout";
import Overview from "@/pages/Overview";
import Inbox from "@/pages/Inbox";
import ChatView from "@/pages/ChatView";
import Pipeline from "@/pages/Pipeline";
import CalendarPage from "@/pages/CalendarPage";
import Analytics from "@/pages/Analytics";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import GoLive from "@/pages/GoLive";
import AcceptInvite from "@/pages/AcceptInvite";
import GetQuote from "@/pages/GetQuote";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Book from "@/pages/Book";
import SmsConsent from "@/pages/SmsConsent";
import Onboarding from "@/pages/Onboarding";
import Billing from "@/pages/Billing";
import InAction from "@/pages/InAction";
import Walkthrough from "@/pages/Walkthrough";
import CompanySmsConsent from "@/pages/CompanySmsConsent";
import CompanyPrivacy from "@/pages/CompanyPrivacy";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/get-quote" element={<GetQuote />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/sms-consent" element={<SmsConsent />} />
          <Route path="/c/:slug/sms-consent" element={<CompanySmsConsent />} />
          <Route path="/c/:slug/privacy" element={<CompanyPrivacy />} />
          <Route path="/book/:leadId" element={<Book />} />
          <Route path="/invite/:token" element={<AcceptInvite />} />
          <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
            <Route index element={<Overview />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="chat" element={<ChatView />} />
            <Route path="chat/:leadId" element={<ChatView />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="team" element={<Team />} />
            <Route path="settings" element={<Settings />} />
            <Route path="go-live" element={<GoLive />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="billing" element={<Billing />} />
            <Route path="in-action" element={<InAction />} />
            <Route path="walkthrough" element={<Walkthrough />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
